import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { TextInput, FormButtons, FormError, ContentBox, PortalForm } from '@portal/kit/pkg/components'

const UpdatePassword = props =>
  <ContentBox title={props.t('portal.reset_password.fill_password')} hasSteps>
    <PortalForm onSubmit={props.handleSubmit}>
      {
        props.submitError && <FormError message={props.submitError} />
      }
      <TextInput type="password" name="password" label={props.t('portal.reset_password.new_password_label')} />
      <TextInput type="password" name="password_confirmation" label={props.t('portal.reset_password.password_confirmation_label')} />
      <FormButtons submit cancel="/" />
    </PortalForm>
  </ContentBox>

UpdatePassword.propTypes = {
  handleSubmit: PropTypes.func.isRequired
}

export default withTranslation()(UpdatePassword)
